"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var progressBar_1 = require("../progressBar");
exports.default = (function (_a) {
    var theme = _a.theme, className = _a.className, orange = _a.orange, purple = _a.purple, label = _a.label, progress = _a.progress, progressValue = _a.progressValue, others = tslib_1.__rest(_a, ["theme", "className", "orange", "purple", "label", "progress", "progressValue"]);
    return (React.createElement("div", tslib_1.__assign({ className: classnames_1.default(theme["progress-graph"], className) }, others),
        React.createElement("div", { className: theme.info },
            React.createElement("div", { className: theme.label }, label),
            React.createElement("div", { className: theme.progress },
                React.createElement("div", { className: theme.percentage },
                    progress,
                    "%"),
                React.createElement("div", { className: theme.value }, progressValue))),
        React.createElement(progressBar_1.ProgressBar, { className: theme.bar, orange: orange, purple: purple, value: progress })));
});
